(function () {
  var fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  var debounceTimer = null;

  function debounce(fn, wait) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fn, wait || 40);
  }

  function parseMoneyToCents(txt) {
    if (!txt) return 0;
    var s = String(txt).replace(/[^\d,.\-]/g, '').trim();
    if (!s) return 0;
    if (s.indexOf(',') >= 0 && s.indexOf('.') >= 0) s = s.replace(/\./g, '');
    s = s.replace(',', '.');
    var euros = parseFloat(s);
    if (isNaN(euros)) return 0;
    return Math.round(euros * 100);
  }

  function parseList(str) {
    return (str || '').split('|').map(function (x) { return parseInt(x, 10) || 0; });
  }

  function box() {
    return document.getElementById('caribia-staffelrabatt');
  }

  // ------- Produkt / Variante -------
  function findProductJSON() {
    var el = document.querySelector('[data-section-type="static-product"][data-section-id][data-section-data]');
    if (!el) return null;
    try {
      return (JSON.parse(el.textContent || el.innerText || '{}') || {}).product || null;
    } catch (e) {
      return null;
    }
  }

  function getSelectedVariant(product) {
    var checked = document.querySelector('input[name="id"]:checked');
    if (checked) {
      var v = product.variants.find(function (x) { return String(x.id) === String(checked.value); });
      if (v) return v;
    }
    var sel = document.querySelector('select[name="id"]');
    if (sel) {
      var v2 = product.variants.find(function (x) { return String(x.id) === String(sel.value); });
      if (v2) return v2;
    }
    return product.selected_or_first_available_variant || product.variants[0];
  }

  // ------- Preis-Quellen -------
  function getShopifyBasePriceEl() {
    var sels = [
      '[data-product-pricing] .price__regular .price-item',
      '[data-product-pricing] .price-item--regular',
      '.product__price .price__regular .price-item',
      '.product__price .price-item--regular',
      '.product-pricing .price__regular .price-item',
      '.product-pricing .price-item--regular'
    ];
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (el) return el;
    }
    return null;
  }

  function getShopifyBasePriceCents() {
    var el = getShopifyBasePriceEl();
    if (!el) return 0;
    return parseMoneyToCents(el.textContent);
  }

  function getAppPriceEl() {
    var b = box();
    var sel = b ? (b.getAttribute('data-price-selector') || '').trim() : '';
    return sel ? document.querySelector(sel) : null;
  }

  function getAppPriceCents() {
    var el = getAppPriceEl();
    if (!el) return 0;
    var attr = el.getAttribute('data-price');
    if (attr && /^\d+$/.test(attr)) return parseInt(attr, 10);
    return parseMoneyToCents(el.textContent);
  }

  function getTotalPriceCents(product) {
    var variant = getSelectedVariant(product);
    var base = getShopifyBasePriceCents() || (variant ? (parseInt(variant.price, 10) || 0) : 0);
    var app = getAppPriceCents();
    if (!app) return base;
    if (base <= 0) return app;
    // Heuristik: App >= 60% Basispreis => Gesamtpreis, sonst Aufpreis
    if (app >= Math.round(base * 0.6)) return app;
    return base + app;
  }

  // ------- Staffelrabatt -------
  function computeStaffelDiscount(totalCents, boundsEUR, amountsEUR) {
    if (amountsEUR.length !== 4 || boundsEUR.length !== 3) return 0;
    var b0 = (boundsEUR[0] || 0) * 100;
    var b1 = (boundsEUR[1] || 0) * 100;
    var b2 = (boundsEUR[2] || 0) * 100;
    var a0 = amountsEUR[0] || 0;
    var a1 = amountsEUR[1] || 0;
    var a2 = amountsEUR[2] || 0;
    var a3 = amountsEUR[3] || 0;

    if (totalCents <= b0) return Math.min(totalCents, a0 * 100);
    if (totalCents <= b1) return Math.min(totalCents, a1 * 100);
    if (totalCents <= b2) return Math.min(totalCents, a2 * 100);
    return Math.min(totalCents, a3 * 100);
  }

  // ------- Hilfsfunktion: aktiven Tier-Index bestimmen -------
  function getActiveTierIndex(totalCents, boundsEUR) {
    if (boundsEUR.length !== 3) return -1;
    var b0 = (boundsEUR[0] || 0) * 100;
    var b1 = (boundsEUR[1] || 0) * 100;
    var b2 = (boundsEUR[2] || 0) * 100;
    if (totalCents <= b0) return 0;
    if (totalCents <= b1) return 1;
    if (totalCents <= b2) return 2;
    return 3;
  }

  // ------- Render (Info-Box über Preis + Modal mit Staffelübersicht) -------
  function render(b, totalCents, staffelCents, boundsEUR, amountsEUR) {
    if (staffelCents > totalCents) staffelCents = totalCents;

    var html = '';

    if (staffelCents > 0) {
      var finalCents = totalCents - staffelCents;

      // Info-Box über dem Preis
      html += '<button type="button" class="csd-info-trigger">';
      html +=   '<span class="csd-info-icon">i</span>';
      html +=   '<span class="csd-info-text">';
      html +=     '<span class="csd-info-title">Staffelrabatte</span>';
      html +=     '<span class="csd-info-sub">Details zu Rabatten anzeigen</span>';
      html +=   '</span>';
      html += '</button>';

      // Preise
      html += '<div class="csd-prices">';
      html +=   '<span class="csd-compare">' + fmt.format(totalCents / 100) + '</span>';
      html +=   '<span class="csd-final">' + fmt.format(finalCents / 100) + '</span>';
      html +=   '<span class="csd-save">- ' + fmt.format(staffelCents / 100) + '</span>';
      html += '</div>';

      html += '<div class="csd-vat-line">inkl. 19% MwSt.</div>';

      // Modal
      html += '<div class="csd-modal">';
      html +=   '<div class="csd-modal-backdrop"></div>';
      html +=   '<div class="csd-modal-dialog" role="dialog" aria-modal="true">';
      html +=     '<button type="button" class="csd-modal-close" aria-label="Schließen">&times;</button>';
      html +=     '<h3 class="csd-modal-title">Staffelrabatte</h3>';
      html +=     '<div class="csd-modal-body">';

      // Staffelübersicht
      if (boundsEUR && amountsEUR && amountsEUR.length === 4 && boundsEUR.length === 3) {
        var activeIdx = getActiveTierIndex(totalCents, boundsEUR);
        html += '<p><strong>Staffelübersicht</strong></p>';

        for (var i = 0; i < 4; i++) {
          var label;
          if (i === 0) {
            label = 'bis ' + fmt.format(boundsEUR[0]);
          } else if (i === 1) {
            label = 'bis ' + fmt.format(boundsEUR[1]);
          } else if (i === 2) {
            label = 'bis ' + fmt.format(boundsEUR[2]);
          } else {
            label = 'ab ' + fmt.format(boundsEUR[2]);
          }

          var rowClass = 'csd-modal-row csd-modal-row--tier';
          if (i === activeIdx) rowClass += ' csd-modal-row--active';

          html += '<div class="' + rowClass + '">';
          html +=   '<span class="csd-modal-row-label">' + label + '</span>';
          html +=   '<span class="csd-modal-row-value">'
                      + fmt.format((amountsEUR[i] || 0)) +
                      (i === activeIdx ? '<span class="csd-modal-tag">aktuell</span>' : '') +
                    '</span>';
          html += '</div>';
        }

        html += '<div class="csd-modal-divider"></div>';
      }

      // Aktueller Staffelrabatt (hervorgehoben)
      html +=       '<div class="csd-modal-row csd-modal-row--highlight">';
      html +=         '<span class="csd-modal-row-label">Ihr Staffelrabatt</span>';
      html +=         '<span class="csd-modal-row-value">- ' + fmt.format(staffelCents / 100) + '</span>';
      html +=       '</div>';

      html +=       '<div class="csd-modal-footnote">';
      html +=         'Der Staffelrabatt ist bereits im angezeigten Preis enthalten.';
      html +=       '</div>';

      html +=     '</div>'; // body
      html +=   '</div>'; // dialog
      html += '</div>'; // modal

    } else {
      // Edge Case: kein Staffelrabatt
      html += '<div class="csd-prices">';
      html +=   '<span class="csd-final">' + fmt.format(totalCents / 100) + '</span>';
      html += '</div>';
      html += '<div class="csd-vat-line">inkl. 19% MwSt.</div>';
    }

    b.innerHTML = html;
  }

  // ------- Update -------
  function doUpdate() {
    var b = box();
    if (!b) return;
    var product = findProductJSON();
    if (!product || !product.variants) return;

    var bounds = parseList(b.getAttribute('data-bounds'));
    var amounts = parseList(b.getAttribute('data-amounts'));

    var total = getTotalPriceCents(product);
    var staffelDisc = computeStaffelDiscount(total, bounds, amounts);

    render(b, total, staffelDisc, bounds, amounts);
  }

  function update() { debounce(doUpdate, 40); }

  // ------- Beobachter nur auf Preisknoten -------
  var baseMO = null, appMO = null;

  function observePriceNode(el) {
    if (!el) return;
    var mo = new MutationObserver(function () { update(); });
    mo.observe(el, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-price']
    });
    return mo;
  }

  function initObservers() {
    if (baseMO) baseMO.disconnect();
    if (appMO) appMO.disconnect();
    baseMO = observePriceNode(getShopifyBasePriceEl());
    appMO = observePriceNode(getAppPriceEl());
  }

  // ------- Click-Handling für Info-Box & Modal -------
  document.addEventListener('click', function (e) {
    // Öffnen
    var trigger = e.target.closest('.csd-info-trigger');
    if (trigger) {
      var root = trigger.closest('#caribia-staffelrabatt');
      if (!root) return;
      var modal = root.querySelector('.csd-modal');
      if (modal) modal.classList.add('is-open');
      return;
    }

    // Schließen (Backdrop oder X)
    if (e.target.classList.contains('csd-modal-backdrop') || e.target.closest('.csd-modal-close')) {
      var modalEl = e.target.closest('.csd-modal') ||
                    document.querySelector('#caribia-staffelrabatt .csd-modal.is-open');
      if (modalEl) modalEl.classList.remove('is-open');
    }
  });

  // Events für Preisänderungen (Varianten/App)
  document.addEventListener('change', update);
  document.addEventListener('input', update);
  document.addEventListener('variant:change', update);
  document.addEventListener('variant:changed', update);

  document.addEventListener('DOMContentLoaded', function () {
    initObservers();
    update();
  });
  window.addEventListener('load', function () {
    initObservers();
    update();
  });

  setInterval(initObservers, 1000);
})();